const audio = new Audio('/msg.mp3')

export function playSound() {
  audio.pause()
  audio.currentTime = 0
  audio.play()
}
